<template>
  <div class="overflow-hidden">
    <!-- Must use v-if or both router-view elements will be rendered, and all pages will be created twice -->
    <div v-if="isAuthenticated">
      <the-main-nav />
      <v-main
        class="overflow-y-auto"
      >
        <div
          v-if="$vuetify.breakpoint.smAndDown"
          class="mobile-bar d-flex align-center"
        >
          <v-btn
            icon
            color="white"
            @click.stop="setDrawer(true)"
          >
            <v-icon>mdi-menu</v-icon>
          </v-btn>
          <div>
            <v-img
              src="/logo-light.svg"
              alt="logo"
              height="30"
              contain
            />
          </div>
        </div>
        <v-fade-transition
          mode="out-in"
        >
          <div :key="currentRouteKey">
            <router-view />
          </div>
        </v-fade-transition>
      </v-main>
    </div>
    <div
      v-else
    >
      <router-view />
    </div>
  </div>
</template>

<script>
import TheMainNav from '@/components/core/the-main-nav'
import { AUTH_TYPES } from '../store/modules/auth'
import { mapGetters, mapMutations } from 'vuex'
import { LAYOUT_TYPES } from '../store/modules/layout'

export default {
  name: 'FullContainer',
  components: { TheMainNav },
  computed: {
    ...mapGetters({
      isAuthenticated: AUTH_TYPES.getters.isAuthenticated,
      currentTenant: AUTH_TYPES.getters.currentTenant
    }),
    currentRouteKey () {
      return this.currentTenant?.id || 0
    }
  },
  /* This handler will capture the errors of any child components, and allow the app to continue functioning.
  * The error will still be propagated to the global error handler, which will send it to App Insights
  * and redirect to the error page.
  */
  errorCaptured: (err) => {
    return err
  },
  methods: {
    ...mapMutations({
      setDrawer: LAYOUT_TYPES.mutations.SET_DRAWER
    })
  }
}
</script>
<style lang="scss" scoped>
  @import '../styles/variables';

  .mobile-bar {
    background-color: $charcoal-grey;
    height: 40px;
    width: 100%;
    padding: 0 4px;

    .v-icon {
      height: 22px;
    }
  }
</style>
